import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  OnInit,
  Output,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { slide } from './feedback.component.animations';
import { Feedback } from '@lockton-apps/shared/interfaces';

interface Score {
  icon: string;
  value: number;
}

@Component({
    selector: 'lui-feedback',
    templateUrl: './feedback.component.html',
    styleUrls: ['./feedback.component.scss'],
    animations: [slide],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class FeedbackComponent implements OnInit {
  @Output() feedbackSubmit: EventEmitter<Feedback> = new EventEmitter();

  feedbackSubmitted!: boolean;
  controller!: FormGroup;

  readonly scores: Score[] = [
    { icon: 'rate_vbad_thin', value: 0 },
    { icon: 'rate_bad_thin', value: 1 },
    { icon: 'rate_neutral_thin', value: 2 },
    { icon: 'rate_good_thin', value: 3 },
    { icon: 'rate_vgood_thin', value: 4 },
  ];

  constructor(private readonly formBuilder: FormBuilder) {}

  ngOnInit(): void {
    this.buildController();
  }

  submitFeedback(feedback: Feedback): void {
    this.controller.markAllAsTouched();
    this.controller.markAsDirty();

    if (this.controller.valid) {
      this.feedbackSubmitted = true;
      this.feedbackSubmit.emit(feedback);
    }
  }

  private buildController(): void {
    this.controller = this.formBuilder.group({
      rate: ['', Validators.required],
      comment: [''],
    });
  }
}
